// extracted by mini-css-extract-plugin
module.exports = {"product-card":"ChooseStoreButton_product-card__seUMa","choose_store":"ChooseStoreButton_choose_store__ZKnoE","button":"ChooseStoreButton_button__Wmgih"};